export default {
  apiUrl() {
    return process.env.VUE_APP_API_URL;
  },
  appTitle() {
    return process.env.VUE_APP_TITLE;
  },
  appUrl() {
    return process.env.VUE_APP_URL;
  },
  shopifyPartnerDashboardUrl() {
    return process.env.VUE_SHOPIFY_PARTNER_DASHBOARD_URL;
  },
  vueAppLoginPath() {
    return process.env.VUE_APP_LOGIN_PATH;
  },
  vueAppPageNotFoundPath() {
    return process.env.VUE_APP_PAGE_NOT_FOUND_PATH;
  },
  vueAppForbiddenPath() {
    return process.env.VUE_APP_FORBIDDEN_PATH;
  },
  vueAppInternalServerErrorPath() {
    return process.env.VUE_APP_INTERNAL_SERVER_ERROR_PATH;
  },
  faqUrl() {
    return "https://help.wholesalehelper.io/hc/en-us/categories/25181680700188-AReceivables";
  },
  calendlyUrl() {
    return "https://calendly.com/wholesale-helper";
  },
  stripeApiKey() {
    return process.env.VUE_APP_STRIPE_API_KEY;
  },
  stripePublicKey() {
    return process.env.VUE_APP_STRIPE_PUBLIC_KEY;
  },
  showStripe() {
    return process.env.VUE_APP_SHOW_STRIPE;
  },
  showOnProduction() {
    return process.env.VUE_APP_ENV === "production";
  },
  defaultFilter() {
    return { name: "Pending payment", value: "pending" };
  },
  getAssetURL() {
    return process.env.VUE_APP_STORAGE;
  },
  maxLimitForMultiSelect() {
    return 10;
  }
};
